import RecoveryPassword from '../../components/authentication/RecoveryPassword'
import { connect } from 'react-redux'
import { actionCreators, recoverPassword } from '../../state/actions/auth/'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState) {
  return {
    isFetching: state.authorization.isFetching,
    isLogged: state.authorization.isLogged,
    isFetchSuccess: state.authorization.isFetchSuccess
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    submit: (data: { [key: string]: string }) => dispatch(recoverPassword(data.emailOrUsername)),
    resetFetchSuccess: () => dispatch(actionCreators.resetFetchSuccess())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecoveryPassword)



// WEBPACK FOOTER //
// ./src/containers/auth/RecoveryPassword.ts